export const GLOBALNOTIFICATION_UPDATE = 'GLOBALNOTIFICATION_UPDATE';